module.exports = __webpack_public_path__ + "static/img/ESI1.978b606.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ESI1.png
// module id = uzNq
// module chunks = 1